<template>
  <v-row class="ma-0">
    <v-col cols="12" sm="6" lg="4">
      <v-card>
        <v-card-text>
          <VAutocomplete label="beacon"
                         :items="beacons"
                         item-text="name"
                         item-value="id"
                         multiple
                         chips
                         deletable-chips
                         v-model="filters.beacons"/>
          <VAutocomplete label="session" :items="sessions" v-model="filters.session_name"/>
          <v-datetime-picker label="Start time"
                             v-model="filters.date_from"
                             :timePickerProps="{format: '24hr'}"
                             ref="dateTimePicker">
            <template #dateIcon>
              <v-icon>far fa-calendar-alt</v-icon>
            </template>
            <template #timeIcon>
              <v-icon>far fa-clock</v-icon>
            </template>
          </v-datetime-picker>
          <v-datetime-picker label="End time"
                             v-model="filters.date_to"
                             :timePickerProps="{format: '24hr'}"
                             ref="dateTimePicker">
            <template #dateIcon>
              <v-icon>far fa-calendar-alt</v-icon>
            </template>
            <template #timeIcon>
              <v-icon>far fa-clock</v-icon>
            </template>
          </v-datetime-picker>
          <VSelect :items="['rssi_average', 'scan_count']" v-model="dataKey" label="data"/>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" lg="8">
      <Chart :options="chartOptions" v-if="filters.beacons && filters.session_name"/>
    </v-col>
  </v-row>
</template>

<script>
import dayjs from 'dayjs';
import {Chart} from 'highcharts-vue';
import qs from 'qs';

export default {
  name: 'Beacons',
  components: {
    Chart,
  },
  data() {
    return {
      dataKey: 'rssi_average',
      filters: {
        beacons: null,
        session_name: '',
        date_to: dayjs().toDate(),
        date_from: dayjs().subtract(5, 'minute').toDate(),
      },
      sessions: [],
      beacons: [],
      measurements: null,
      chartOptions: {
        title: {
          text: '',// keeping this empty so the default text won't appear
        },
        chart: {
          zoomType: 'x',
        },
        xAxis: {
          type: 'datetime',
        },
        series: [],
      },
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.search();
      },
    },
    dataKey: {
      handler() {
        this.search();
      },
    },
  },
  async created() {
    this.sessions = await this.fetchSessions();
    this.beacons = await this.fetchBeacons();
  },
  methods: {
    async search() {
      if (!this.filters.beacons || !this.filters.session_name) return;
      this.measurements = await this.fetchMeasurements();
      this.formatData(this.dataKey);
    },
    async fetchMeasurements() {
      const response = await this.$http.get('https://measurement.flok.boekit.nl/api/beacon-measurement', {
        params: {
          ...this.filters,
          date_from: this.filters.date_from ? dayjs(this.filters.date_from).format('YYYY-MM-DD HH:mm:ss') : null,
          date_to: this.filters.date_to ? dayjs(this.filters.date_to).format('YYYY-MM-DD HH:mm:ss') : null,
        },
        paramsSerializer: params => {
          return qs.stringify(params);
        },
      });
      return response.data.data;
    },
    async fetchSessions() {
      const response = await this.$http.get('https://measurement.flok.boekit.nl/api/session');
      return response.data.data;
    },
    async fetchBeacons() {
      const response = await this.$http.get('https://measurement.flok.boekit.nl/api/beacon');
      return response.data.data;
    },
    formatData(dataKey = 'rssi_average') {
      this.chartOptions.series = [];
      this.measurements.forEach(data => {
        this.chartOptions.series.push({
          name: data.name, data: data.measurements.map(measurement => {
            return [dayjs(measurement.date).valueOf(), measurement[dataKey]];
          }),
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
